import { render } from "./KidDetails.vue?vue&type=template&id=c360e196&scoped=true"
import script from "./KidDetails.vue?vue&type=script&lang=js"
export * from "./KidDetails.vue?vue&type=script&lang=js"

import "./KidDetails.vue?vue&type=style&index=0&id=c360e196&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vue-soft/vue-soft/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c360e196"]])

export default __exports__